// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2OLSv","content":"styles_content__1GtVR","selectAll":"styles_selectAll__1C5b_"};